import { COUPONS_API } from 'modules/coupons/api/coupon-api'
import { CouponInterface } from 'modules/coupons/types/coupon-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useCoupon(id: string) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, CouponInterface>({
    method: RequestMethodsEnum.get,
  })

  return useSWR(() => {
    if (user) {
      return `${COUPONS_API}/${id}`
    }
  }, fetcher)
}
